import { useRefinementList } from 'react-instantsearch'

import { Checkbox } from '@/components/primitives/Checkbox/Checkbox'
import { cn } from '@/lib/utils'

export const FacetOptions = ({ facet, show }: { show: boolean; facet: string }) => {
  const { items, refine } = useRefinementList({
    attribute: facet,
    operator: 'or',
    showMore: true,
    sortBy: ['name:asc'],
  })

  return (
    <div
      className={cn(
        'no-scrollbar absolute inset-0 z-[1] flex size-full transform-gpu flex-col gap-8 overflow-y-scroll rounded-r-xl bg-white p-6 transition-opacity duration-300',
        show ? 'opacity-1' : 'pointer-events-none opacity-0 ',
      )}
    >
      <div className="flex flex-col gap-5">
        {items?.map((item) => (
          <div key={item.value} className="flex items-center justify-between text-grey-700">
            <Checkbox
              label={item.label}
              id={item.label}
              checked={item.isRefined}
              onChange={() => {
                refine(item.value)
              }}
            />
            <span className="text-grey-500">({item.count})</span>
          </div>
        ))}
      </div>
    </div>
  )
}
